<template>
  <div :id="'model-live-box-' + video.id" class="video-container">
    <ClientOnly>
      <vue-plyr ref="plyr" :options="plyrOptions">
        <video :autoplay="false" controls playsinline ref="videoRef">
          <source src="" type="video/mp4" />
        </video>
      </vue-plyr>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import VuePlyr from "vue-plyr";
import Hls from "hls.js";
import { hlsConfigComCredenciais } from "~/util/hls-config";
import "vue-plyr/dist/vue-plyr.css";

const plyr = ref<HTMLVideoElement | null>(null);

const hls = new Hls(hlsConfigComCredenciais);

const props = defineProps(["video"]);
const videoSrc = ref("");
const videoRef = ref<HTMLVideoElement | null>(null);
const showIcon = ref(true);

const plyrOptions = ref({
  controls: []
});

watch(() => props.video, async () => {
  showIcon.value = true;  
  videoSrc.value = await getVideo();
});

watch(
  () => videoSrc.value,
  () => {
    if (videoSrc.value) {
      if (videoRef.value) {
        videoRef.value.src = videoSrc.value;
      }
    }
  }
);

watch(() => videoRef.value,
  async (el) => {
    if (el) {
      videoSrc.value = await getVideo();
     }
  },
  { immediate: true }
 );

onUnmounted(() => {
  if (hls) {
    hls.destroy();
  }
});

async function getVideo() {
  const videosUrl = props.video.path;

  if (Hls.isSupported() && videoRef.value) {
    hls.loadSource(videosUrl);
    hls.attachMedia(videoRef.value);
    return "";
  } else if (
    videoRef.value &&
    videoRef.value.canPlayType("application/vnd.apple.mpegurl")
  ) {
    return videosUrl;
  }

  return videosUrl;
}

function firefox() {
  return navigator?.userAgent.includes("Firefox");
  // return false
}
</script>

<style scoped>
.full video {
  aspect-ratio: 16 / 9;
}
video {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: contain;
}

.video-container {
  position: relative;
}

.video-container-ios {
  position: fixed; /* Fixa o contêiner na tela */
  top: 0;
  left: 0;
  width: 100vw; /* Largura total da viewport */
  height: 100vh; /* Altura total da viewport */
  background-color: black; /* Fundo preto para simular fullscreen */
  z-index: 9999; /* Coloca o contêiner acima de outros elementos */
}

.video-container-ios iframe {
  height: 100vh;
}

.full {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.full iframe {
  height: 100vh;
}

.fullscreen-button {
  position: absolute;
  top: 3%;
  right: 1%;
  z-index: 10;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Tamanho do ícone de reprodução */
  color: white;
  /* Cor do ícone de reprodução */
  cursor: pointer;
  z-index: 1;
}

i[class*="icon-"]:before {
  color: #ffffff;
  font-size: 25px;
}

@media screen and (max-width: 970px) {
  .video-container-ios {
    width: 100vw;
  }
}
</style>
